import { useContext } from 'react';
import type { PlanName } from '../../types/api';
import { PlanContext, type PlanContextValue } from './planContext';

/** The account's plan and what it allows. Requires `PlanProvider`. */
export function usePlan(): PlanContextValue {
  const value = useContext(PlanContext);
  if (!value) {
    throw new Error('usePlan must be used inside PlanProvider.');
  }
  return value;
}

/**
 * The account's plan name, or null while unknown. Safe outside `PlanProvider`
 * (it answers null there), so shared upload pickers can name the plan in a
 * cap message without requiring the shell.
 */
export function usePlanName(): PlanName | null {
  return useContext(PlanContext)?.entitlements?.plan ?? null;
}
